export default "__VITE_ASSET__BbQE821T__"